import './style.scss';

const Spinner = () => {
    return (
        <svg className="mx-auto my-0 mb-3 spinner" width="64" height="64" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32ZM8 32C8 45.2548 18.7452 56 32 56C45.2548 56 56 45.2548 56 32C56 18.7452 45.2548 8 32 8C18.7452 8 8 18.7452 8 32Z"
                fill="#EBF2FF"
                className="sppiner-bg"
            ></path>
            <path
                d="M32 4C32 1.79086 33.7977 -0.0257507 35.9896 0.249677C38.8211 0.605472 41.5983 1.33919 44.2459 2.43586C48.1283 4.04401 51.6559 6.40111 54.6274 9.37259C57.5989 12.3441 59.956 15.8717 61.5641 19.7541C63.1723 23.6366 64 27.7977 64 32C64 36.2023 63.1723 40.3635 61.5641 44.2459C59.956 48.1283 57.5989 51.656 54.6274 54.6274C51.6559 57.5989 48.1283 59.956 44.2458 61.5642C41.5983 62.6608 38.8211 63.3945 35.9896 63.7503C33.7977 64.0257 32 62.2091 32 60C32 57.7909 33.803 56.0339 35.9815 55.6674C37.7624 55.3678 39.508 54.8675 41.1844 54.1731C44.0962 52.967 46.7419 51.1992 48.9706 48.9706C51.1992 46.742 52.967 44.0962 54.1731 41.1844C55.3792 38.2726 56 35.1517 56 32C56 28.8483 55.3792 25.7274 54.1731 22.8156C52.967 19.9038 51.1992 17.258 48.9706 15.0294C46.742 12.8008 44.0962 11.033 41.1844 9.82689C39.5081 9.13253 37.7624 8.63217 35.9815 8.33257C33.803 7.96608 32 6.20914 32 4Z"
                fill="#3D5AFF"
                className="sppiner-principal"
            ></path>
        </svg>
    );
};

export default Spinner;
